import * as React from "react"

import "./spinner.scss"

interface Spinner {
	className?: string
}

const Spinner: React.FC<Spinner> = ({ className = "" }) => {
	return (
		<div className={`lds-ring ${className}`}>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	)
}

export default Spinner
